export class PersonalReferenceTable {
    code: number;
    fullName: string;
    phone: string;
    relationship: string;
    status: boolean;
    constructor() {
        this.code = 0;
        this.fullName = "";
        this.phone = "";
        this.relationship = "";
        this.status = false;
    }
}